"use client";
import Hyperlink from "@/components/ui/hyperlink";
import { useModalContext } from "@/contexts/ModalContext";
import Image from "next/image";

const AboutArea = ({ imgSrc, title, description, btn1, btn2, description2, altText }: { imgSrc: string, title: string, description: string, btn1?: string, btn2?: string, description2: string, altText?: string }) => {
    const modal = useModalContext();

    const handleModalOpen = (modalTitle?: string) => {
        modal.openModal(modalTitle);
    };
    return (
        <>
            <section className="desilo-about2-section bg-color-white section-padding-top">
                <div className="container custom-container">
                    <div className="row align-items-stretch ">
                        <div className="col-xl-6">
                            <div className="desilo-about2__thumb overflow-hidden pe-xl-4 h-100">
                                <Image
                                    height={0}
                                    width={0}
                                    sizes="100vw"
                                    src={imgSrc}
                                    alt={altText || ''}
                                    className="w-100 h-100 object-fit-cover"
                                />
                            </div>
                        </div>
                        <div className="col-xl-6 gsap-scroll row-margin-top2">
                            <div className="desilo-about2__content ps-xl-4 position-sticky sticky-col">
                                <h2>
                                    {title}
                                </h2>
                                <p className="mt-3 mt-lg-4">
                                    {description}
                                </p>
                                {btn1 && btn2 && (
                                    <div className="d-flex align-items-center gap-4">
                                        <Hyperlink
                                            className="mt-4 mt-xl-5"
                                            variant="modal"
                                            onModalOpen={handleModalOpen}
                                            modalTitle={btn1}
                                        >
                                            {btn1}
                                        </Hyperlink>
                                        <Hyperlink
                                            className="mt-4 mt-xl-5"
                                            variant="modal"
                                            onModalOpen={handleModalOpen}
                                            modalTitle={btn2}
                                        >
                                            {btn2}
                                        </Hyperlink>
                                    </div>
                                )}
                                {btn1 && !btn2 && (
                                    <div className="d-flex align-items-center gap-4">
                                        <Hyperlink
                                            className="mt-4 mt-xl-5 cursor-pointer"
                                            variant="modal"
                                            onModalOpen={handleModalOpen}
                                            modalTitle={btn1}
                                        >
                                            {btn1}
                                        </Hyperlink>
                                    </div>
                                )}
                                <p className="italic-text">
                                    {description2}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default AboutArea;
